import { render } from "./InspectionPricing.vue?vue&type=template&id=532f727c"
import script from "./InspectionPricing.vue?vue&type=script&lang=js"
export * from "./InspectionPricing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/InspectionPricing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "532f727c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('532f727c', __exports__)) {
    api.reload('532f727c', __exports__)
  }
  
  module.hot.accept("./InspectionPricing.vue?vue&type=template&id=532f727c", () => {
    api.rerender('532f727c', render)
  })

}


export default __exports__